<template>
  <span :class="badgeClass" class="badge fw-bold px-3 py-2">
    {{ status | formatCampaignStatus }}
  </span>
</template>

<script>
export default {
  props: ['status'],
  computed: {
    badgeClass () {
      const badgeMap = {
        ACTIVE: 'badge-light-success',
        PENDING: 'badge-light-warning',
        FINISHED: 'badge-light-dark',
        PAUSED: 'badge-light-primary',
        ERROR: 'badge-light-danger',
        FAILED: 'badge-light-danger',
        DRAFT: 'badge-light-dark'
      }
      return badgeMap[this.status] || 'badge-light-dark'
    }
  }
}
</script>

<style lang="scss" scoped>
  .badge-light-primary {
    background-color: rgba(216, 171, 68, .15) !important;
  }
</style>
